import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { RetroBonuses, RetroBonusesFilters, RewardDocumentsFilters } from '../types';

export default class RetroBonusesState extends BaseState {
  retro_bonuses_loading = false;
  retro_bonuses: RetroBonuses.RetroBonus[] = [];
  organizations: string[] = [];

  reward_documents: RetroBonuses.RewardDocument[] = [];
  reward_document_details = {} as RetroBonuses.RewardDocumentDetail;
  reward_document_products: RetroBonuses.RewardDocumentProducts[] = [];

  scenarios: RetroBonuses.RetroScenarios[] = [];

  reward_documents_filters: RewardDocumentsFilters = {
    scenarios: [],
  };

  contract_info: RetroBonuses.Contract = {
    number_contract: '',
    date: '',
    id: 0,
  };

  filters: RetroBonusesFilters = {
    search: '',
    organizations: '',
    dates: [],
  }

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };
}
